import { STORAGE_KEYS } from '../../../shared/utils/constants';

export function useSandboxMode() {
  const orgRole = sessionStorage.getItem(STORAGE_KEYS.ORGANIZATION_ROLE);
  return orgRole === 'SANDBOX';
}

export default useSandboxMode;
